export const API = {
	Login : "https://api-ap-northeast-2-user.rayteams.com/login",
	UserUpdatePassword : "https://api-ap-northeast-2-user.rayteams.com/requrestpasswordemail",
	UserUpdateInfo : "https://api-ap-northeast-2-user.rayteams.com/",
}
